import { FLITCH_EXPENSES_FAILED, FLITCH_EXPENSES_REQUEST, FLITCH_EXPENSES_SUCCESS } from "app/redux/actions/Master/Expenses/FlitchExpenses/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const flitchExpensesReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case FLITCH_EXPENSES_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCH_EXPENSES_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCH_EXPENSES_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};